/// <amd-module name="TFS/Admin/Views/SettingsSearch/Contracts/DataModels" />

import { SearchScope, SettingResult } from "TFS/Admin/Common/Contracts/Search.Shared";
import { IListBoxItem } from "VSSUI/ListBox";
import { DropdownSelection } from "VSSUI/Utilities/DropdownSelection";

export namespace SettingsSearchConstants {
    export const GetProjectsListError = "GetProjectsCatchError";
    export const GetTeamsListError = "GetTeamsCatchError";
    export const ZeroDataImage = "ms.vss-tfs-web/platform-content/Illustrations/general-no-results-found-v2.svg";
    export const SettingsSeachFeatureFlag = "ms.vss-admin-web.organization-admin-settings-search-feature";
}

export const SettingsSearchRoutes = [
    "ms.vss-admin-web.collection-admin-hub-route",
    "ms.vss-admin-web.project-admin-hub-route",
    "ms.vss-admin-web.user-admin-hub-route",
    "ms.vss-code-web.branches-route",
    "ms.vss-releaseManagement-web.hub-explorer-3-default-route",
    "ms.vss-build-web.pipelines-hub-route",
    "ms.vss-work-web.query-route-basic",
    "ms.vss-dashboards-web.dashboards-singledashboard-route",
    "ms.vss-analytics.analytics-hub-route",
    "ms.vss-distributed-task.hub-task-group-default-route"
];

export interface SearchScopeSelection {
    value?: IListBoxItem;
    selection: DropdownSelection;
}

export interface SearchResultSet {
    setTitle: string;
    results: SettingResult[];
    seachScope: SearchScope;
}

export const enum OperationState {
    Loading = 0,
    Normal = 1,
    Error = 2
}

export interface ISettingsSearchComponentState {}
